export const selectStyles = {
    control: (base: any, state: any) => ({
        ...base,
        minHeight: '44px',
        background: state.isFocused ? '#e8e9ef' : '#f0f1f5',
        border: `1.5px solid ${state.isFocused ? '#c5c9d3' : '#e2e5ea'}`,
        borderRadius: '10px',
        fontSize: '14px',
        boxShadow: 'none',
        outline: 'none',
        '&:hover': { borderColor: '#c5c9d3', boxShadow: 'none' },
    }),
    valueContainer: (base: any) => ({ ...base, padding: '0 16px' }),
    option: (base: any, state: any) => ({
        ...base,
        fontSize: '14px',
        backgroundColor: state.isSelected ? '#19c9dd' : state.isFocused ? '#f0fdff' : '#fff',
        color: state.isSelected ? '#171a3d' : '#101426',
    }),
    placeholder: (base: any) => ({ ...base, color: '#667085', fontSize: '14px' }),
    indicatorSeparator: () => ({ display: 'none' }),
    menu: (base: any) => ({ ...base, zIndex: 9999 }),
    container: (base: any) => ({ ...base, gap: 0 }),
};
